export const NULL_DATE = '0001-01-01T00:00:00Z'
